import { Spa } from "@mui/icons-material";
import { Box, Button } from "@mui/material";
import { useStore } from "@priolo/jon";
import NumberField from "components/controls/fields/NumberField";
import Paragraph from "components/controls/form/Paragraph";
import Modal from "components/controls/Modal";
import { FunctionComponent } from "react";
import cycleDialogSo from "stores/cycle/editDialog";



interface Props {
}
const CropLotEditDialog: FunctionComponent<Props> = ({
}) => {

    // STORE
    useStore(cycleDialogSo)

    // HOOKs

    // HANDLEs
    const handleParamChange = (param: any) => {
        if (!param) return
        cycleDialogSo.setEditCropLot({ ...cropLot, ...param })
    }
    const handleClose = () => cycleDialogSo.setEditCropLotOpen(false)
    const handleSave = () => cycleDialogSo.saveCropLot()

    // RENDER
    const cropLot = cycleDialogSo.state.editCropLot
    if (!cropLot) return null

    return <Modal
        maxWidth="xs"
        icon={<Spa />}
        title={"EDIT CROP LOT"}
        isOpen={cycleDialogSo.state.editCropLotOpen}
        onClose={handleClose}
        actionsRender={<>
            <div style={{ flex: "1 1 auto" }} />

            <Button
                onClick={handleClose}
            >CANCEL</Button>

            <Button
                onClick={handleSave}
                color="secondary"
            //disabled={!canSave}
            >SAVE</Button>
        </>}
    >

        <Box sx={{ display: "flex", flexDirection: "column" }}>

            <Paragraph title={"SEED USED"} flex={1}>
                <NumberField sx={{ width: "100px" }} endAdornment="g"
                    min={1}
                    value={cycleDialogSo.state.editCropLot?.seedUsedG}
                    onChangeNumber={(value) => handleParamChange({ seedUsedG: parseInt(value) })}
                />
            </Paragraph>

            <Paragraph title={"GEL USED"} flex={1}>
                <NumberField sx={{ width: "100px" }} endAdornment="g"
                    min={1}
                    value={cycleDialogSo.state.editCropLot?.gelUsedG}
                    onChangeNumber={(value) => handleParamChange({ gelUsedG: parseInt(value) })}
                />
            </Paragraph>

        </Box>
    </Modal>
}

export default CropLotEditDialog